import React from "react";
import HOC from "../../../components/HOC";
import ListRequestWarehouse from "../../../components/screen/centralWarehouse/request/ListRequestWarehouse";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const RequestAllocationListPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Request Allocation"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ListRequestWarehouse type={4} />
          </ThemeProvider>
        }
        pageRole={37}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(RequestAllocationListPage);
